import React, { useEffect, useMemo } from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  Box,
  Avatar,
  Button,
  Container,
  Paper,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  TextareaAutosize,
  Stack,
  Divider,
  Grid,
  Autocomplete,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableBody,
  TableCell,
  InputAdornment,
  capitalize,
  Fab,
  Chip,
  FormControlLabel,
  Checkbox,
} from '@mui/material';
import AppTheme from '../../../shared-theme/AppTheme';
import { CssBaseline } from '@mui/material';
import SideMenu from '../../../components/SideMenu';
import Header from '../../../components/Header';
import Can from '../../../components/Can';
import { Add, ArrowBack, CalculateOutlined, SearchOutlined, TableChart } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import Selector from '../../../components/Selector';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import dayjs from 'dayjs';
import { StyledCellHeader } from '../../../components/StyledCellHeader';
import CrearBancoDialog from '../../configuracion/bancos/crearbancodialog';
import CrearMonedaDialog from '../../configuracion/monedas/crearmonedadialog';
import AutocompleteWithAdd from '../../../components/AutocompleteWithAdd';
import { fetchBancos, fetchClientes, fetchMonedas, fetchPortafolios, fetchProductosFinancieros, fetchProveedores } from '../../../utils/generalsFetch';
import { formatIdentification, formatNumber, formatNumberWithCommas, formatPhone, parseCampos } from '../../../utils/generalFunctions';
import { gray } from '../../../shared-theme/themePrimitives';
import CobrarInicialDialog from './iniciales/cobrarinicialdialog';
import { calculoabsoluto, calculoinsoluto, calculoplazoindefinido, calcularInteresPorCuota } from './funciones/funciones';
import AlertMessageDialog from '../../../components/Dialogs/alertMessageDialog';
import OnGeneralMessageDialog from '../../../components/Dialogs/OnGeneralMessageDialog';
import { useTourContext } from '../../../components/TourProvider';
import { categoriasGarantia, camposGarantia } from '../../../utils/staticvariables';
import AmortizationDrawer from './components/AmortizationDrawer';


export default function CrearPrestamo() {
  const navigate = useNavigate();
  // Global tour context
  const { startSpecificTour } = useTourContext();
  const [openCobrarInicial, setOpenCobrarInicial] = React.useState(false);
  const [montoInicial, setMontoInicial] = React.useState(0);
  const [montoInicialText, setMontoInicialText] = React.useState("0");
  const [moneda, setMoneda] = React.useState({ label: '' });
  const [valorCuota, setValorcuotas] = React.useState(0);
  const [deudaTotal, setDeudaTotal] = React.useState(0);
  const [openAlert, setOpenAlert] = React.useState(false);
  const [alertMessage, setAlertMessage] = React.useState('');
  const [alertSeverity, setAlertSeverity] = React.useState('success');
  const [clientes, setClientes] = React.useState([]);
  const [paymentDataInicial, setPaymentDataInicial] = React.useState(null);
  const [categoriasGarantiaOptions, setCategoriasGarantiaOptions] = React.useState(categoriasGarantia);
  const [camposGarantiaData, setCamposGarantiaData] = React.useState(camposGarantia);

  const showErrorAlert = (message) => {
    setAlertMessage(message);
    setAlertSeverity('error');
    setOpenAlert(true);
  };

  const showSuccessAlert = (message) => {
    setAlertMessage(message);
    setAlertSeverity('success');
    setOpenAlert(true);
  };
  const [clienteSelected, setClienteSelected] = React.useState(null);
  const [clienteInputValue, setClienteInputValue] = React.useState('');
  const [isInicialCreated, setIsInicialCreated] = React.useState(false);
  const [formValuesGarantia, setFormValuesGarantia] = React.useState({});
  const [errorsGarantia, setErrorsGarantia] = React.useState({});
  const [fechaSolicitud, setFechaSolicitud] = React.useState(dayjs());
  const [fechaPrestamoInicio, setFechaPrestamoInicio] = React.useState(dayjs().format('YYYY-MM-DD'));
  const [openDateConfirmDialog, setOpenDateConfirmDialog] = React.useState(false);
  const [dateConfirmCallback, setDateConfirmCallback] = React.useState(null);
  const [amortizationDrawerOpen, setAmortizationDrawerOpen] = React.useState(false);
  const [isSaving, setIsSaving] = React.useState(false);
  const [diasPagoQuincenal, setDiasPagoQuincenal] = React.useState({ dia1: '', dia2: '' });
  const diaQuincVacio = (d) => d === '' || d == null;
  const diasQuincenalDefinidos = !diaQuincVacio(diasPagoQuincenal.dia1) && !diaQuincVacio(diasPagoQuincenal.dia2);

  const [financialProductSelected, setFinancialProductSelected] = React.useState(null);
  const [formulario, setFormulario] = React.useState({
    "campos": 
    [{"id": 2, "name": "Cédula / Identificación", "type": "ID", "options": [], "category": "Datos personales", "required": true, "deletelable": false}, 
    {"id": 1, "name": "Nombre completo", "type": "texto", "options": [], "category": "Datos personales", "required": true, "deletelable": false}, 
    {"id": 3, "name": "Fecha de nacimiento", "type": "fecha", "options": [], "category": "Datos personales", "required": true, "deletelable": false},
    {"id": 4, "name": "Estado civil", "type": "opciones", "options": ["Soltero", "Casado", "Divorciado", "Viudo"], "category": "Datos personales", "required": true}, 
    {"id": 1753886767728, "name": "Celular", "type": "numerotel", "options": [], "category": "Datos personales", "required": true, "deletelable": false}, 
    {"id": 5, "name": "Teléfono", "type": "numerotel", "options": [], "category": "Datos personales", "required": true, "deletelable": true}, 
    {"id": 6, "name": "Dirección residencial", "type": "texto", "options": [], "category": "Datos personales", "required": true, "deletelable": false},
    {"id": 7, "name": "Ocupación / Profesión", "type": "texto", "options": [], "category": "Información laboral", "required": true, "deletelable": true}, 
    {"id": 8, "name": "Empresa donde labora", "type": "texto", "options": [], "category": "Información laboral", "required": false, "deletelable": true}, 
    {"id": 9, "name": "Ingreso mensual", "type": "monto", "options": [], "category": "Información laboral", "required": true, "deletelable": true}, 
    {"id": 10, "name": "Monto solicitado", "type": "monto", "options": [], "category": "Datos del préstamo", "required": true, "deletelable": false}, 
    {"id": 12, "name": "Frecuencia de pago", "type": "opciones", "options": [], "category": "Datos del préstamo", "required": true, "deletelable": false}, 
    {"id": 11, "name": "Plazo del préstamo ", "type": "numero", "options": [], "category": "Datos del préstamo", "required": true, "deletelable": false}, 
    {"id": 13, "name": "Interes", "type": "numero", "options": [], "category": "Datos del préstamo", "required": false, "deletelable": true},
    {"id": 14, "name": "Mora", "type": "numero", "options": [], "category": "Datos del préstamo", "required": false, "deletelable": true},
    ], 
     "categorias": [{"id": 1, "name": "Datos personales", "deletelable": false}, 
      {"id": 3, "name": "Datos del préstamo", "deletelable": false}, 
      ]})

  const [general, setGeneral] = React.useState({"tipo": "credito_consumo", 
    "nombre": "Repuestos credito", "autorizado": false, "sucursales": ["a0e60aeb-134d-4a38-b21d-75a094703d89"], 
    "formaDePago": ["Mensual", "Quincenal"], "montoMaximo": 20000, "montoMinimo": 100, "requiereSolicitud": true, 
    "requiereInventario": true, "categoriasInventario": ["710123b4-a09e-4dbf-9ddc-6bafd0d62944"]})

  const [mora, setMora] = React.useState({"tipoMora": "fija", "valorMora": "5", "esPorcentaje": true})
  const [interes, setInteres] = React.useState({"tipoInteres": "fijo", "valorInteres": "5"});
  const [calculateByCuota, setCalculateByCuota] = React.useState(false);
  const [customCuota, setCustomCuota] = React.useState(0);

  const [productoSelected, setProductoSelected] = React.useState(null);
  const [productos, setProductos] = React.useState([])
  const [camposInventario, setCamposInventario] = React.useState([{"id": "id", "name": "id", "type": "texto", "alias": "chasis", "options": [], "prefijo": "", "required": true, "inputValue": "", "deletelable": false}, 
    {"id": "costo", "name": "Costo", "type": "monto", "alias": "", "options": [], "prefijo": "", "required": true, "inputValue": "", "deletelable": false}, 
    {"id": "precio_venta", "name": "Precio de venta", "type": "monto", "alias": "", "options": [], "prefijo": "", "required": true, "inputValue": "", "deletelable": false}, 
    {"id": 1751896599709, "name": "usado", "type": "opciones", "alias": "", "options": ["si", "no"], "prefijo": "", "required": false, "inputValue": "", "deletelable": true},
    {"id": 1752693666066, "name": "Modelo", "type": "texto", "alias": "", "options": [], "prefijo": "", "required": false, "inputValue": "", "deletelable": true},
    {"id": 1752693674472, "name": "Color", "type": "texto", "alias": "", "options": [], "prefijo": "", "required": false, "inputValue": "", "deletelable": true}])

  const [formValues, setFormValues] = React.useState({})
  const [errors, setErrors] = React.useState({});
  const [productosFinancieros, setProductosFinancieros] = React.useState([]);
  const [portafolios, setPortafolios] = React.useState([]);

  useEffect(() => {
    fetchMonedas({ usuarioId: localStorage.getItem('id'), idcompany: localStorage.getItem('idcompany') }).then((data) => {
      const defaultMoneda = data?.find((m) => m.value == "1") || data?.[0] || { label: '' };
      setMoneda(defaultMoneda);
    }).catch((error) => {
      console.log(error);
    });
    fetchProductosFinancieros({ usuarioId: localStorage.getItem('id'), idcompany: localStorage.getItem('idcompany') }).then((data) => {
      setProductosFinancieros(data);
    }).catch((error) => {
      console.log(error);
    });
    fetchClientes({ usuarioId: localStorage.getItem('id'), idcompany: localStorage.getItem('idcompany') }).then((data) => {
      setClientes(data);
    }).catch((error) => {
      console.log(error);
    });
    fetchPortafolios({ usuarioId: localStorage.getItem('id'), idcompany: localStorage.getItem('idcompany') }).then((data) => {
      setPortafolios(data.map(portafolio => ({ label: portafolio.nombre, value: portafolio.id })));
    }).catch((error) => {
      console.log(error);
    });

  }, []);

  useEffect(() => {
    if (productoSelected) {
      // `productoSelected.campos` puede llegar como string JSON (recién traído
      // del backend) o como objeto (cuando ya fue mutado en handleInputChange).
      // Lo normalizamos y exponemos sus claves (precio_venta, costo, id, ...)
      // dentro de formValues para que el resto del formulario las pueda leer.
      const camposObj = parseCampos(productoSelected.campos);
      const precioNum = parseFloat(camposObj.precio_venta) || 0;
      const inicialNum = parseFloat(montoInicial) || 0;
      setFormValues((prev) => ({
        ...prev,
        ...camposObj,
        [10]: precioNum - inicialNum,
      }));
    }
  }, [productoSelected, montoInicial]);


  useEffect(() => {
    if(calculateByCuota){
      // Validate if customCuota is entered
      alert("ksks")
      if(!customCuota || customCuota <= 0){
        setDeudaTotal(0);
        setValorcuotas(0);
        return;
      }
      
      if(formValues[10] && formValues[11] && formValues[12]){
        alert(formValues[10]);
        var data = calcularInteresPorCuota(formValues[10], formValues[11], customCuota, formValues[12]);
        setDeudaTotal(data["deuda"]);
        setValorcuotas(customCuota);
        // Update interest field with calculated interest only if it changed
        var calculatedInterest = parseFloat(data["interes"]);

        if(calculatedInterest !== formValues[13]){
          setInteres(prev => ({ ...prev, tasa: data["interes"] }));
          setFormValues(prev => ({ ...prev, [13]: calculatedInterest }));
        }
      }
    }
    else if(interes.tipoInteres == "fija"){
      if(formValues[10] && formValues[11] && formValues[12]){
      var data = calculoabsoluto(formValues[10],formValues[11],formValues[13],formValues[12]);
      setDeudaTotal(data["deuda"]);
      setValorcuotas(data["cuotas"]);
      }
    }
    else if(interes.tipoInteres == "insoluto"){
      
      var data = calculoinsoluto(formValues[10], formValues[11], formValues[13], formValues[12], fechaPrestamoInicio);
      setDeudaTotal(data["deuda"]);
      setValorcuotas(data["cuotas"]);
    }
    else{
      var data = calculoplazoindefinido(formValues[10],formValues[13],formValues[12]);
      setDeudaTotal(data["deuda"]);
      setValorcuotas(data["cuotas"]);
    }
  },[formValues, customCuota, calculateByCuota, interes.tipoInteres])

  const handleInputChange = (id, value) => {
    setFormValues((prevValues) => ({
      ...prevValues,
      [id]: value,
    }));

    if(value != "") {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [id]: undefined, 
      }));
    }
    else{

      if( formulario.campos.find(campo => campo.id == id)?.required) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          [id]: `${formulario.campos.find(campo => campo.id == id).name} es requerido`, 
        }));
      }
    }
    
    var calculo = 0
    var error = undefined
    // `parseFloat("")` y `parseInt("")` dan NaN; con `|| 0` evitamos que NaN
    // se propague a formValues[10] cuando el usuario borra los campos.
    const inicialNum = parseFloat(montoInicial) || 0;
    switch (id) {
      case "precio_venta":
        calculo = (parseFloat(value) || 0) - inicialNum;
        // Sincronizamos el precio dentro de productoSelected.campos para que
        // el resto del UI (campo "Monto solicitado", inventario, etc.) lea el
        // valor actualizado en el siguiente render.
        if (productoSelected) {
          const camposObj = parseCampos(productoSelected.campos);
          setProductoSelected({
            ...productoSelected,
            campos: { ...camposObj, precio_venta: value },
          });
        }
        break;
      case "inicial":
        calculo = (parseFloat(formValues["precio_venta"]) || 0) - (parseFloat(value) || 0);
        break;
      default:
        return;
    }
    if (calculo < general.montoMinimo || calculo > general.montoMaximo) {
      error = `Monto debe ser entre ${moneda?.label+"$"+formatNumberWithCommas(general.montoMinimo.toFixed(2))} - ${moneda?.label+"$"+formatNumberWithCommas(general.montoMaximo.toFixed(2))}`
    }

    setFormValues((prevValues) => ({
      ...prevValues,
      [10]: calculo,
    }));

    setErrors((prevErrors) => ({
      ...prevErrors,
      [10]: error,
    }));




  };

  // Calculate amortization data dynamically whenever form values change
  const amortizationData = useMemo(() => ({
    montoSolicitado: Number(formValues[10]) || 0,
    cuotaEstimada: calculateByCuota ? customCuota || 0 : valorCuota || 0,
    deudaTotal: deudaTotal || 0,
    plazo: interes.tipoInteres === 'plazo_indefinido' ? 'Indefinido' : formValues[11],
    frecuencia: formValues[12],
    interes: formValues[13],
    mora: formValues[14],
    moraEsPorcentaje: mora.esPorcentaje,
    metodo: interes.tipoInteres,
    fechaInicio: fechaPrestamoInicio,
    producto: general.nombre,
    formasPago: general.formaDePago,
    sucursales: general.sucursales,
    observaciones: general.descripcion,
    moneda: moneda?.label || '',
    diasPagoQuincenal:
      interes.tipoInteres !== 'plazo_indefinido' && formValues[12] === 'Quincenal' ? diasPagoQuincenal : null,
  }), [
    formValues[10], formValues[11], formValues[12], formValues[13], formValues[14],
    calculateByCuota, customCuota, valorCuota, deudaTotal,
    interes.tipoInteres, mora.esPorcentaje,
    fechaPrestamoInicio, general.nombre, general.formaDePago, general.sucursales, general.descripcion,
    moneda?.label, diasPagoQuincenal
  ]);

  const handleOpenAmortizationDrawer = () => {
    setAmortizationDrawerOpen(true);
  };

  const handleInputChangeGarantia = (id, value) => {
    setFormValuesGarantia((prevValues) => ({
      ...prevValues,
      [id]: value,
    }));

    setErrorsGarantia((prevErrors) => ({
      ...prevErrors,
      [id]: undefined,
    }));

    if(value != "") {
      setErrorsGarantia((prevErrors) => ({
        ...prevErrors,
        [id]: undefined,
      }));
    }
    else{
      setErrorsGarantia((prevErrors) => ({
        ...prevErrors,
        [id]: `${camposGarantiaData.find(categoria => categoria.value === formValues.categoriasGarantia)?.campos.find(campo => campo.id === id).name} es requerido`,
      }));
    }
  }

  const validateForm = () => {
    let isValid = true;
    const newErrors = {};

    formulario.campos.forEach((campo) => {
      if (campo.required && !formValues[campo.id]) {
        newErrors[campo.id] = `${campo.name} es requerido`;
        isValid = false;
      } else {
        newErrors[campo.id] = undefined
      }
    });
    if(general.requiereInventario && !productoSelected) {
      newErrors["producto"] = "Producto es requerido";
      isValid = false;
    }
    else{
      if(productoSelected && general.requiereInventario){
        newErrors["producto"] = undefined;
        camposInventario.forEach((campo) => {
          if (campo.required && !formValues[campo.id]) {
            if(formValues[campo.id]==0 && campo.type == "monto") {
              return;
            }
            newErrors[campo.id] = `${campo.name} es requerido`;
            isValid = false;
          }
          else {
            newErrors[campo.id] = undefined
          }
        });
      }
    }
    if (formValues[10] < general.montoMinimo || formValues[10] > general.montoMaximo) {
      newErrors[10] = `Monto debe ser entre ${moneda?.label+"$"+formatNumberWithCommas(general.montoMinimo.toFixed(2))} - ${moneda?.label+"$"+formatNumberWithCommas(general.montoMaximo.toFixed(2))}`;
      isValid = false;
    }

    const esQuincenalConDias = interes.tipoInteres !== 'plazo_indefinido' && formValues[12] === 'Quincenal';
    const algunDiaVacio = diaQuincVacio(diasPagoQuincenal.dia1) || diaQuincVacio(diasPagoQuincenal.dia2);
    if (esQuincenalConDias && algunDiaVacio && !(diaQuincVacio(diasPagoQuincenal.dia1) && diaQuincVacio(diasPagoQuincenal.dia2))) {
      newErrors.diasPagoQuincenal = 'Seleccione ambos días de pago quincenal o deje los dos vacíos';
      isValid = false;
    } else if (esQuincenalConDias && diasQuincenalDefinidos && Number(diasPagoQuincenal.dia1) === Number(diasPagoQuincenal.dia2)) {
      newErrors.diasPagoQuincenal = 'Seleccione dos días distintos del mes para las cuotas quincenales';
      isValid = false;
    } else {
      newErrors.diasPagoQuincenal = undefined;
    }

    

    setErrors(newErrors);
    return isValid;
  
  }

  const validateFormGarantia = () => {
    let isValid = true;
    const newErrors = {};
    camposGarantiaData.find(categoria => categoria.value === formValues.categoriasGarantia)?.campos.forEach((campo) => {
      if (campo.required && !formValuesGarantia[campo.id]) {
        newErrors[campo.id] = `${campo.name} es requerido`;
        isValid = false;
      }
      else{
        newErrors[campo.id] = undefined
      }
    });

    setErrorsGarantia(newErrors);
    return isValid;
  }


  const handleGuardar = async () => {
    // Check if fecha_solicitud is not equal to today's date
    const today = dayjs().startOf('day');
    const selectedDate = fechaSolicitud ? dayjs(fechaSolicitud).startOf('day') : null;
    
    if (selectedDate && !selectedDate.isSame(today, 'day')) {
      // Store the callback to continue with save
      
      setDateConfirmCallback(() => () => {
        setOpenDateConfirmDialog(false);
        continueWithSave();
      });
      
      setOpenDateConfirmDialog(true);
      return;
    }

    // If date is correct, continue with save
    continueWithSave();
  }

  const continueWithSave = async () => {
    if(!validateForm()) {
      return;
    }
    if(!validateFormGarantia()) {
      return;
    }

    setIsSaving(true);
    
    try {
      var clienteId = null

    if(!clienteSelected){
      var url = `${process.env.REACT_APP_SERVER_URL}/api/clientes`;
      const datosPersonalesCampos = formulario.campos.filter(campo => campo.category == "Datos personales");
      const datosPersonalesIds = datosPersonalesCampos.map(campo => campo.id);
      const datosPersonalesValues = Object.fromEntries(
        Object.entries(formValues).filter(([key, value]) => datosPersonalesIds.includes(Number(key) || key))
      );
      var data = {
        "identificacion": formValues[2],
        "campos": datosPersonalesValues,
        "idcompany": localStorage.getItem('idcompany'),
        "created_by": localStorage.getItem('id')
      }

      var response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Usuario-ID': localStorage.getItem('id'),
          'X-company-ID': localStorage.getItem('idcompany')
        },
        body: JSON.stringify(data)
      });

      if (!response.ok) {
        const error = await response.json();
        console.log(error);
        showErrorAlert(`Error al crear cliente: ${error.error || error.message || 'Error desconocido'}`);
        setIsSaving(false);
        return;
      }
      clienteId = (await response.json()).id;
    }
    else{
      var url = `${process.env.REACT_APP_SERVER_URL}/api/clientes/${clienteSelected.id}`;
      const datosPersonalesCampos = formulario.campos.filter(campo => campo.category == "Datos personales");
      const datosPersonalesIds = datosPersonalesCampos.map(campo => campo.id);
      const datosPersonalesValues = Object.fromEntries(
        Object.entries(formValues).filter(([key, value]) => datosPersonalesIds.includes(Number(key) || key))
      );

      var data = {
        "identificacion": formValues[2],
        "campos": datosPersonalesValues,
        "idcompany": localStorage.getItem('idcompany'),
        "created_by": localStorage.getItem('id')
      }

      var response = await fetch(url, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'X-Usuario-ID': localStorage.getItem('id'),
          'X-company-ID': localStorage.getItem('idcompany')
        },
        body: JSON.stringify(data)
      });

      if (!response.ok) {
        const error = await response.json();
        console.log(error);
        showErrorAlert(`Error al actualizar cliente: ${error.error || error.message || 'Error desconocido'}`);
        setIsSaving(false);
        return;
      }
      clienteId = clienteSelected.id;


    }
    var producto = general.requiereInventario ? productoSelected.id : "no_requiere_inventario";
    var id_solicitud = null;
    
    var url = `${process.env.REACT_APP_SERVER_URL}/api/solicitudes-prestamo`;
    var data = {
      "idcompany": localStorage.getItem('idcompany'),
      "id_productofinanciero": financialProductSelected,
      "id_cliente": clienteId,
      "sucursal":localStorage.getItem('id_sucursal'),
      "estado": general.requiereSolicitud ? "abierta" : "aceptada",
      "campos": formValues,
      "created_by": localStorage.getItem('id'),
      "producto": producto,
      "precio_venta": general.requiereInventario ? formValues["precio_venta"] : 0,
      "inicial_id":general.requiereInventario ? productoSelected.inicial_id?productoSelected.inicial_id:"no existe" : "no existe",      
      "identificacion":formValues[2],
      "nombre":formValues[1],
      "monto_inicial":montoInicial,
      "garantia": general.requiereGarantia ? formValuesGarantia : "no existe",
      "categoria_garantia":formValues.categoriasGarantia,
      "created_inicial":isInicialCreated,
      "fecha_solicitud": fechaSolicitud ? fechaSolicitud.format('YYYY-MM-DD HH:mm:ss') : dayjs().format('YYYY-MM-DD HH:mm:ss'),
      "fecha_inicio_prestamo": fechaPrestamoInicio || dayjs().format('YYYY-MM-DD'),
      "inicial_metodo_pago":paymentDataInicial?.payments?.map(payment => ({
        method: payment.method,
        amount: payment.amount,
        reference: payment.reference
      }))

    }
    var response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Usuario-ID': localStorage.getItem('id'),
        'X-company-ID': localStorage.getItem('idcompany')
      },
      body: JSON.stringify(data)
    });

    if (!response.ok) {
      const error = await response.json();
      console.log(error);
      showErrorAlert(`Error al crear solicitud: ${error.error || error.message || 'Error desconocido'}`);
      setIsSaving(false);
      return;
    }
    var data = await response.json();
    id_solicitud = data.id;

    if(!general.requiereSolicitud && id_solicitud){
      var url = `${process.env.REACT_APP_SERVER_URL}/api/prestamos`;
      var dataPrestamo = {
        "idcompany": localStorage.getItem('idcompany'),
        "id_solicitud": id_solicitud,
        "id_sucursal": localStorage.getItem('id_sucursal'),
        "id_cliente": clienteId,
        "monto_solicitado": formValues[10],
        "monto_inicial": montoInicial,
        "interes": formValues[13],
        "mora_porcentaje": formValues[14],
        "frecuencia": formValues[12],
        "metodo": interes.tipoInteres,
        "interes_diario": interes.interesDiario,
        "plazo": formValues[11],
        "producto":general.requiereInventario?productoSelected["id"]:"no_requiere_inventario",
        "precio_venta":general.requiereInventario?formValues["precio_venta"]:0,
        "created_by": localStorage.getItem('id'),
        "fecha_solicitud": fechaSolicitud ? fechaSolicitud.format('YYYY-MM-DD') : dayjs().format('YYYY-MM-DD'),
        "fecha_inicio": fechaPrestamoInicio || dayjs().format('YYYY-MM-DD'),
        ...((interes.tipoInteres !== 'plazo_indefinido' && formValues[12] === 'Quincenal' && diasQuincenalDefinidos)
          ? { dias_pago_quincenal: [Number(diasPagoQuincenal.dia1), Number(diasPagoQuincenal.dia2)] }
          : {}),
      }
      var responsePrestamo = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-company-ID': localStorage.getItem('idcompany'),
            'X-Usuario-ID': localStorage.getItem('id')
        },
        body: JSON.stringify(dataPrestamo)
      });
      if (!responsePrestamo.ok) {
        const error = await responsePrestamo.json();
        console.log(error);
        showErrorAlert(`Error al crear préstamo: ${error.error || error.message || 'Error desconocido'}`);
        setIsSaving(false);
        return;
      }
      var dataPrestamo = await responsePrestamo.json();
      console.log(dataPrestamo);
    }

    showSuccessAlert(`Tu ${general.requiereSolicitud?"solicitud":"préstamo"} se ha creado con éxito.`);
    setIsSaving(false);
    } catch (error) {
      console.error('Error in continueWithSave:', error);
      setIsSaving(false);
      showErrorAlert('Error inesperado al guardar. Por favor intenta nuevamente.');
    }

    
  
 
  }


  const guardarMontoInicial = (monto,montoText,paymentData) => {
    setMontoInicial(monto);
    setMontoInicialText(montoText);
    setOpenCobrarInicial(false);
    setIsInicialCreated(true);
    setPaymentDataInicial(paymentData);

    // Aquí puedes agregar la lógica para guardar el monto inicial en el producto seleccionado
    console.log("Monto inicial guardado:", monto, montoText);
    handleInputChange("inicial", monto);

  }

  const onProductoFinancieroChange = async(e) => {
    var producto = productosFinancieros.find(producto => producto.idprodfinanciero === e.target.value);
    setFinancialProductSelected(producto.idprodfinanciero);
    const generalesParsed = JSON.parse(producto.generales);
    setGeneral(generalesParsed);
    setFormulario(JSON.parse(producto.formulario));
    setCamposInventario(JSON.parse(producto.fields));
    setMora(JSON.parse(producto.mora));
    setInteres(JSON.parse(producto.interes));
    setFormValues({13: JSON.parse(producto.interes).tasa,14:JSON.parse(producto.mora).valorMora})

    // Get category ID from generales.categoriasInventario (stored in JSON)
    // The query joins catinventario, so producto.id might be the category ID, but categoriasInventario is more reliable
    const idcategoria = generalesParsed?.categoriasInventario || producto.id || null;
    
    if (!idcategoria) {
      showErrorAlert('No se encontró la categoría de inventario para este producto financiero');
      return;
    }

    let url = `${process.env.REACT_APP_SERVER_URL}/api/productos/${localStorage.getItem('idcompany')}/${idcategoria}?estado=disponible`;

    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'X-company-ID': localStorage.getItem('idcompany'),
          'X-Usuario-ID': localStorage.getItem('id')
        },
      });
  
      if (!response.ok) {
        const error = await response.json();
        console.log(error);
        showErrorAlert(`Error al cargar productos: ${error.error || error.message || 'Error desconocido'}`);
        return;
      }

      var data = await response.json();
      setProductos(data["productos"]);
  
    } catch (error) {
      console.log(error);
//      showErrorAlert(`Error de conexión al cargar productos: ${error.message || 'Error desconocido'}`);
    }
  }

  const handleClienteChange = (val) => {
    if (val && typeof val === 'object') {
      setClienteSelected(val);
      setClienteInputValue(formatIdentification(val.identificacion)); // <-- Nuevo
      handleInputChange(2, formatIdentification(val.identificacion));
      handleClienteSearch(formatIdentification(val.identificacion));
    } else if (val && typeof val === 'string') {
      const formattedValue = formatIdentification(val);
      setClienteInputValue(formattedValue); // <-- Nuevo
      handleInputChange("2", formattedValue);
      var cliente = clientes.find(cliente => cliente.identificacion === formattedValue);
      if(cliente) {
        setClienteSelected(cliente);
        handleClienteSearch(cliente.identificacion);
      } else {
        setClienteSelected(null);
      }
    } else {
      setClienteSelected(null);
      setClienteInputValue(''); // <-- Nuevo
      handleInputChange("2", '');
    }
  };
  
  const handleClienteInputChange = (event, newInputValue,reason) => {
    
    if (reason === 'input') {
      const formattedValue = formatIdentification(newInputValue);
      setClienteInputValue(formattedValue); // Esto mantiene formateado el input
      handleInputChange("2", formattedValue); // Actualiza el campo de identificación en el formValues
      handleClienteSearch(formattedValue);
    } else if (reason === 'clear') {
      setClienteInputValue('');
      handleInputChange("2", '');
      handleClienteSearch('');
    }
  }

  const handleClienteSearch = (val) => {
    var cliente = clientes.find(cliente => cliente.identificacion === val);
    if(cliente) {
      setClienteSelected(cliente);
      // Find same keys in clientesselected.campos and formulario.campos.id
      var campos = JSON.parse(cliente.campos);
      var camposFormulario = formulario.campos;
      var matchingKeys = camposFormulario
        .filter(campo => Object.keys(campos).includes(String(campo.id)))
        .map(campo => {
          return {
            [campo.id]: campos[campo.id]
          }
        });
      var matchingKeysObj = matchingKeys.reduce((acc, curr) => {
        return { ...acc, ...curr };
      }, {});

      setFormValues((prevValues) => ({
        ...prevValues,
        ...matchingKeysObj,
      }));
    } else {
      setClienteSelected(null);
//      setFormValues({});
    }
  }

  const handleProductoChange = (val) => {
    setProductoSelected(val || null);
    setMontoInicial(val?.monto_inicial ?? 0);
  }

  const today = dayjs().startOf('day');
  const selectedDate = fechaSolicitud ? dayjs(fechaSolicitud).startOf('day') : null;
  const formattedSelectedDate = selectedDate ? selectedDate.format('DD/MM/YYYY') : '';
  const formattedToday = today.format('DD/MM/YYYY');

  return (
    <Box>
      <AlertMessageDialog message={alertMessage} title={''} severity={alertSeverity} color={alertSeverity} open={openAlert} handleClose={()=>{setOpenAlert(false);if(alertSeverity === 'success') navigate(-1)}}/>
      <OnGeneralMessageDialog
        open={openDateConfirmDialog}
        onClose={() => setOpenDateConfirmDialog(false)}
        title="Confirmar Fecha de Solicitud"
        message={`La fecha de solicitud seleccionada (${formattedSelectedDate}) es diferente a la fecha actual (${formattedToday}). ¿Estás seguro de que esta fecha es correcta?`}
        buttonText="Sí, continuar"
        onRegister={dateConfirmCallback || (() => {})}
        buttonColor="primarybutton"
      />
      <AppTheme themeComponents={{}}>
        <CssBaseline enableColorScheme />
        <CobrarInicialDialog moneda={moneda} open={openCobrarInicial} onClose={()=>{setOpenCobrarInicial(false)}} onConfirm={guardarMontoInicial} productoSelected={productoSelected} camposInventario={camposInventario}></CobrarInicialDialog>
        <Box sx={{ display: 'flex' }}>
          <SideMenu />
          <Box component="main" sx={{ flexGrow: 1, overflow: 'auto' }}>
              <Stack
                  spacing={2}
                  sx={{
                  alignItems: 'center',
                  mx: 3,
                  pb: 5,
                  mt: { xs: 8, md: 0 },
                  }}>

                  <Header 
                    parent={"Gestion Comercial"} 
                    child={"Prestamos"} 
                    onStartTour={startSpecificTour}
                  />
                  <Container maxWidth={"xl"} sx={{ px: { xs: 2, md: 10 }, py: 5, display: "flex", justifyContent: "center", flexDirection: "column", backgroundColor: "transparent"}}>
                      <Box dividers display={"flex"} justifyContent={"flex-start"} alignItems={"center"} >
                          <Button variant="outlined" startIcon={<ArrowBack/>} onClick={()=>{navigate(-1)}}>Atras</Button>
                          <Box display={"flex"} flexDirection={"column"} gap={2} ml={5} flex={1}>
                              <Typography variant="h4" fontWeight={700} textAlign={"left"}>Crear Prestamo</Typography>
                              <Typography variant="body1" color="text.secondary" textAlign={"left"} sx={{mt:-1}}>Agregar un pago a una factura de proveedor</Typography>
                          </Box>
                          <Box sx={{ ml: 2, visibility: 'hidden' }}>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <DatePicker
                                label="Fecha de Solicitud"
                                value={fechaSolicitud}
                                onChange={(newValue) => {
                                  setFechaSolicitud(newValue);
                                }}
                                format="DD/MM/YYYY"
                                slotProps={{
                                  textField: {
                                    size: 'small',
                                    sx: { minWidth: 200 }
                                  },
                                }}
                              />
                            </LocalizationProvider>
                          </Box>
                      </Box>

                      { financialProductSelected ? (
                          <Grid container spacing={3}>
                            <Grid item size={12}>
                              <Box boxShadow={1} p={2} borderRadius={3} mt={2} padding={5} data-tour="seleccionar-producto-inicial">
                                  <Selector
                                    sx={{marginTop:2}}
                                    value={financialProductSelected}
                                    onChange={(e) => onProductoFinancieroChange(e)}
                                    options={productosFinancieros.map(producto => ({label:JSON.parse(producto.generales).nombre,value:producto.idprodfinanciero}))}
                                    placeholder="Tipo de producto"/>
                                  <Grid container spacing={2} mt={2}>
                                    <Grid item size={12}>
                                      <Typography fontSize={16} fontWeight={600} textAlign={"left"}>Nombre</Typography>
                                      <Typography variant="body1" color="text.secondary" textAlign={"left"}>{general.nombre}</Typography>
                                    </Grid>
                                    <Grid item size={6}>
                                      <Typography fontSize={16} fontWeight={700} textAlign={"left"}>Monto Minimo</Typography>
                                      <Typography variant="body1" color="text.secondary" textAlign={"left"}>{moneda?.label}${formatNumberWithCommas(general.montoMinimo.toFixed(2))}</Typography>
                                    </Grid>
                                    <Grid item size={6}>
                                      <Typography fontSize={16} fontWeight={700} textAlign={"left"}>Monto Maximo</Typography>
                                      <Typography variant="body1" color="text.secondary" textAlign={"left"}>{moneda?.label}${formatNumberWithCommas(general.montoMaximo.toFixed(2))}</Typography>
                                    </Grid>
                                    <Grid item size={6}>
                                      <Typography fontSize={16} fontWeight={700} textAlign={"left"}>Interes</Typography>
                                      <Typography variant="body1" color="text.secondary" textAlign={"left"}>{interes.tipoInteres} {interes.tasa}%</Typography>
                                    </Grid>
                                    <Grid item size={6}>
                                      <Typography fontSize={16} fontWeight={700} textAlign={"left"}>Mora</Typography>
                                      <Typography variant="body1" color="text.secondary" textAlign={"left"}>{mora.tipoMora} {mora.valorMora} {mora.esPorcentaje ? "%" : ""}</Typography>
                                    </Grid>
                                    <Grid item size={6}>
                                      <Typography fontSize={16} fontWeight={700} textAlign={"left"}>Requiere Solicitud?</Typography>
                                      <Typography variant="body1" color="text.secondary" textAlign={"left"}>{general.requiereSolicitud ? "Si" : "No"}</Typography>
                                    </Grid>
                                    <Grid item size={6}>
                                      <Typography fontSize={16} fontWeight={700} textAlign={"left"}>Requiere Autorizacion si no cumple parametros?</Typography>
                                      <Typography variant="body1" color="text.secondary" textAlign={"left"}>{general.autorizado ? "Si" : "No"}</Typography>
                                    </Grid>

                                  </Grid>
                                </Box>
                                    
                                {formulario.categorias.map((categoria) => {
                                    var camposCategoria = formulario.campos.filter(campo => campo.category === categoria.name);
                                    
                                    return (
                                      <>
                                      {categoria.id==3 && general.requiereInventario && (
                                      <Box boxShadow={1} p={2} borderRadius={3} mt={2} padding={5} data-tour="seleccion-inventario">
                                        <Grid container spacing={2}>
                                            <Grid item size={12}>
                                                <Typography variant="h6" fontWeight={700} textAlign={"left"}>{capitalize(camposInventario[0].alias + " para financiamiento")}</Typography>
                                                <Typography textAlign={"left"} mx={1} fontSize={12} color="error">{errors["producto"]}</Typography>
                                                
                                            </Grid>
                                            <Grid item size={12}>
                                              <Autocomplete
                                                options={productos}
                                                renderInput={(params) => <TextField {...params} placeholder="Productos" fullWidth/>}
                                                onChange={(e, val) => {handleProductoChange(val)}}
                                                renderOption={(props, option) => (
                                                  <Box component="li" {...props}>
                                                    <Box sx={{ display: 'flex', flexDirection:"row", width: '100%' }}>
                                                      <Box sx={{display:"flex", flexDirection:"row"}}>
                                                        <Typography variant="body2" sx={{ flexGrow: 1 }}>
                                                          {parseCampos(option?.campos).id ?? ''}
                                                          
                                                        </Typography>
                                                        {option?.monto_inicial && (
                                                          <Chip 
                                                          sx={{mx:2}}
                                                            label={`Inicial: ${moneda?.label}$${formatNumberWithCommas(option.monto_inicial)}`}
                                                            size="small"
                                                            color="primary"
                                                            variant="outlined"
                                                          />
                                                        )}
                                                      </Box>
                                                    </Box>
                                                  </Box>
                                                )}
                                                getOptionLabel={(option) => option ? String(parseCampos(option.campos).id ?? '') : ''}
                                                isOptionEqualToValue={(option, value) => option?.id === value?.id}
                                                value={productoSelected}
                                                />
                                            </Grid>
                                            {productoSelected && camposInventario.map((campo,index) => {
                                              var value = parseCampos(productoSelected.campos)[campo.id];
//                                              alert(JSON.stringify(campo.id));


                                            
                                              
                                              return(
                                                <>
                                              <Grid item size={4} key={campo.id}>
                                                <Typography fontWeight={600} textAlign={"left"} mx={1} color={"textSecondary"}>{campo.id=="id"?capitalize(campo.alias):capitalize(campo.name)}</Typography>
                                                <TextField
                                                  slotProps={{
                                                    input: {
                                                      startAdornment:campo.type === 'monto' ? (
                                                        <InputAdornment position="start">{moneda?.label}$</InputAdornment>
                                                      ) : null,
                                                    },
                                                  }}
                                                  error={errors[campo.id]!=undefined? true : false}
                                                  helperText={errors[campo.id]}
                                                  fullWidth
                                                  value={campo.type=="numero" || campo.type=="monto" ?formatNumberWithCommas(value?.toString()): value}
                                                  onChange={(e) => {
                                                    var newValue = parseInt(e.target.value.replaceAll(/,/g, ''));
                                                    handleInputChange(campo.id, newValue);
                                                  }}
                                                  disabled={campo.id=="precio_venta"?false:true}
                                                  />
                                              </Grid>
                                              {index == camposInventario.length-1 && (
                                                <Grid item size={4}>
                                                  <Typography fontWeight={600} textAlign={"left"} mx={1} color={"textSecondary"}>Inicial</Typography>
                                                  <TextField
                                                    slotProps={{
                                                      input: {
                                                        startAdornment: <InputAdornment position="start">{moneda?.label}$</InputAdornment>,
                                                        endAdornment: <InputAdornment position="end">
                                                          {!productoSelected.monto_inicial && (
                                                            <Can modulo="iniciales" accion="crear">
                                                              <Button sx={{mx:-2,bgcolor:"primary.main",color:"white", fontWeight:600}} variant="contained" color={"primary.main"} size="small" onClick={() => {setOpenCobrarInicial(true)}} startIcon={<Add></Add>}> Agregar Inicial</Button>
                                                            </Can>
                                                          )}
                                                        </InputAdornment>,
                                                      },
                                                    }}
                                                    fullWidth
                                                    value={formatNumberWithCommas(montoInicial)}
                                                    disabled={true}
                                                  />
                                                  {productoSelected.monto_inicial && (
                                                    <>
                                                      <Typography variant="body2" sx={{mx:1,textAlign:"left"}}>Descripcion: {productoSelected.descripcion}</Typography>
                                                      <Typography variant="body2" sx={{mx:1,textAlign:"left"}}>Cliente: {productoSelected.identificacion} - {productoSelected.nombre}</Typography>
                                                    </>
                                                  )}


                                                </Grid>
                                              )}
                                              </>
                                              )
                                            })}
                                        </Grid>
                                      </Box>
                                    )}
                                    <Box boxShadow={1} p={2} borderRadius={3} mt={2} padding={5} data-tour={`formulario-${categoria.name.toLowerCase().replace(/\s+/g, '-')}`}>
                                        <Grid container spacing={2}>
                                            <Grid item size={12}>
                                                <Typography variant="h6" fontWeight={700} textAlign={"left"}>{categoria.name}</Typography>
                                            </Grid>
                                            {categoria.name === "Datos del préstamo" && (
                                              <Grid item size={4}>
                                                <Typography fontWeight={600} textAlign={"left"} mx={1} color={"textSecondary"}>{"Fecha de inicio"}</Typography>
                                                <TextField
                                                  fullWidth
                                                  value={fechaPrestamoInicio}
                                                  onChange={(e) => {
                                                    setFechaPrestamoInicio(e.target.value);
                                                  }}
                                                  type="date"
                                                />
                                            </Grid>
                                            
                                            )}
                                            {categoria.name === "Datos del préstamo" && general.permitirSeleccionarPortafolio && (
                                              <Grid item size={4}>
                                                <Typography fontWeight={600} textAlign={"left"} mx={1} color={"textSecondary"}>{"Portafolio"}</Typography>
                                                <Selector
                                                  options={portafolios}
                                                  value={formValues.portafolio}
                                                  onChange={(e) => {
                                                    setFormValues({...formValues, portafolio: e.target.value});
                                                  }}
                                                  placeholder="Seleccionar portafolio"
                                                />
                                              </Grid>
                                            )}
                                            {camposCategoria.map((campo) => {
                                              var helper = ""
                                              switch (campo.id) {
                                                case 10:
                                                  helper = `Monto debe ser entre ${moneda?.label+"$"+formatNumberWithCommas(general.montoMinimo.toFixed(2))} - ${moneda?.label+"$"+formatNumberWithCommas(general.montoMaximo.toFixed(2))}`;
                                                  break;
                                                case 13:
                                                  helper = "Interes de tipo "+interes.tipoInteres+" "+interes.tasa+"%";
                                                  break;
                                                case 14:
                                                  var esPorcentaje = mora.esPorcentaje ? " %" : "";
                                                  helper = "Mora de tipo "+mora.tipoMora+" "+mora.valorMora+esPorcentaje;
                                                  break;  
                                              }
                                              if(interes.tipoInteres === 'plazo_indefinido' && campo.id === 11){
                                                return null;
                                              }
                                                return (
                                                    <Grid item size={4} key={campo.id}>
                                                      <Typography fontWeight={600} textAlign={"left"} mx={1} color={"textSecondary"}>{campo.name}</Typography>
                                                      {campo.type === "ID" && campo.id === 2 ? (
                                                        <Autocomplete
                                                            options={clientes}
                                                            getOptionLabel={(option) => option.identificacion || ""}
                                                            renderInput={(params) => <TextField {...params} placeholder="Clientes" fullWidth />}
                                                            onChange={(e, val) => handleClienteChange(val)}
                                                            onInputChange={(e, newInputValue, reason) => {handleClienteInputChange(e, newInputValue,reason)}}
                                                            inputValue={clienteInputValue}
                                                            value={clienteSelected}
                                                          />
                                                        ) : campo.type === "ID" ? (
                                                          <TextField
                                                            fullWidth
                                                            error={errors[campo.id]!=''? true : false}
                                                            helperText={errors[campo.id]}
                                                            placeholder={campo.name}
                                                            value={formatIdentification(formValues[campo.id]?formValues[campo.id]:'') || ''}
                                                            onChange={(e) => {
                                                                handleInputChange(campo.id, e.target.value);
                                                            }}
                                                            required={campo.required}
                                                        />
                                                        ) : null}

                                                        {campo.type === "texto" && (
                                                            <TextField
                                                                fullWidth
                                                                error={errors[campo.id]!=''? true : false}
                                                                helperText={errors[campo.id]}
                                                                placeholder={campo.name}
                                                                value={formValues[campo.id] || ''}
                                                                onChange={(e) => {
                                                                    handleInputChange(campo.id, e.target.value);
                                                                }}
                                                                required={campo.required}
                                                            />
                                                        )}
                                                        {campo.type === "numerotel" && (
                                                            <TextField
                                                                fullWidth
                                                                error={errors[campo.id]!=undefined? true : false}
                                                                helperText={errors[campo.id]}
                                                                placeholder={campo.name}
                                                                value={formatPhone(formValues[campo.id]) || ''}
                                                                onChange={(e) => {
                                                                    handleInputChange(campo.id, e.target.value);
                                                                }}
                                                                required={campo.required}
                                                            />
                                                        )}
                                                        {campo.type === "fecha" && (
                                                            <TextField
                                                                fullWidth
                                                                placeholder={campo.name}
                                                                error={errors[campo.id]!=undefined? true : false}
                                                                helperText={errors[campo.id]}
                                                                type="date"
                                                                value={formValues[campo.id] || ''}
                                                                onChange={(e) => {
                                                                    handleInputChange(campo.id, e.target.value);
                                                                }}
                                                                required={campo.required}
                                                            />
                                                        )}
                                                        {campo.type === "monto" && (
                                                        <TextField
                                                            slotProps={{
                                                                input: {
                                                                    startAdornment: (
                                                                        <InputAdornment position="start">{moneda?.label}$</InputAdornment>
                                                                    ),
                                                                },
                                                            }}
                                                            helperText={helper}
                                                            error={errors[campo.id]!=undefined? true : false}
                                                            fullWidth
                                                            disabled={campo.id === 10 && general.requiereInventario? true : false}
                                                            placeholder={campo.name}
                                                            value={campo.id==10 && general.requiereInventario ? formatNumberWithCommas((parseFloat(parseCampos(productoSelected?.campos).precio_venta) || 0)-parseFloat(montoInicial)) : formatNumberWithCommas(formValues[campo.id]?.toString()) || ''}
                                                            onChange={(e) => {
                                                                var value = parseInt(e.target.value.replaceAll(/,/g, ''));
                                                                handleInputChange(campo.id,value);
                                                            }}
                                                            required={campo.required}/>
                                                          )  
                                                        }
                                                        

                                                        {campo.type === "numero" && (
                                                            <TextField
                                                              helperText={helper!="" ? helper : errors[campo.id]}
                                                              error={errors[campo.id]!=undefined? true : false}
                                                              fullWidth
                                                              placeholder={campo.name}
                                                              type="number"
                                                              disabled={campo.id === 13 ? calculateByCuota : false}
                                                              value={formValues[campo.id] || ''}
                                                              onChange={(e) => {
                                                                  handleInputChange(campo.id, e.target.value);
                                                              }}
                                                              required={campo.required}
                                                            />
                                                          
                                                        )}
                                                        {campo.type === "opciones" && (
                                                            <FormControl fullWidth>
                                                                <Selector
                                                                    helperText={errors[campo.id]}
                                                                    error={errors[campo.id]!=undefined? true : false}
                                                                    value={formValues[campo.id] || ''}
                                                                    onChange={(e) => {
                                                                      handleInputChange(campo.id, e.target.value);
                                                                    }}
                                                                    options={campo.options.map(option => ({ label: option, value: option }))}
                                                                    placeholder={campo.name}/>

                                                            </FormControl>
                                                        )}
                                                    </Grid>
                                                );
                                            
                                            })}

                                        </Grid>
                                        
                                        {/* Add Custom Cuota Calculation Option for Datos del préstamo */}
                                        {categoria.name === "Datos del préstamo" && !interes.interesDiario && (
                                          <Box sx={{ mt: 2, p: 2, bgcolor: '#f5f5f5', borderRadius: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 2 }}>
                                            <Button
                                              variant="outlined"
                                              color="primary"
                                              startIcon={<TableChart />}
                                              sx={{ fontWeight: 'bold' }}
                                              onClick={handleOpenAmortizationDrawer}
                                              disabled={(() => {
                                                  const monto = Number(
                                                    String(formValues[10] ?? '').replaceAll(/,/g, '')
                                                  );
                                                
                                                if (!Number.isFinite(monto) || monto <= 0) return true;
                                                if (formValues[12] == null || formValues[12] === '') return true;
                                                // Préstamos con interés diario: exigen plazo (campo 11) para poder proyectar cuotas
                                                if (
                                                  interes.tipoInteres !== 'plazo_indefinido' &&
                                                  interes.interesDiario
                                                ) {
                                                  const plazoN = Number(formValues[11]);
                                                  if (!Number.isFinite(plazoN) || plazoN <= 0) return true;
                                                }
                                                // Quincenal: los días se eligen en el panel; no bloquear el botón aunque falte validar (evita cierre al abrir)
                                                return false;
                                              
                                              })()}
                                            >
                                              Calcular cuotas
                                            </Button>
                                          </Box>
                                        )}
                                    </Box>
                                    {/*<Box sx={{ mt: 2, p: 2, bgcolor: '#f5f5f5', borderRadius: 1 }}>
                                            <FormControlLabel
                                              control={
                                                <Checkbox
                                                  checked={calculateByCuota}
                                                  onChange={(e) => {
                                                    setCalculateByCuota(e.target.checked);
                                                    if (!e.target.checked) {
                                                      setCustomCuota(0);
                                                    }
                                                  }}
                                                />
                                              }
                                              label="Calcular interés basado en cuota fija"
                                            />
                                            {calculateByCuota && (
                                              <Grid container spacing={2} sx={{ mt: 1 }} alignItems="center" justifyContent="center">
                                                <Grid item size={4}>
                                                  <Typography fontWeight={600} textAlign={"left"} color={"textSecondary"}>Cuota fija</Typography>
                                                  <TextField
                                                    fullWidth
                                                    error={calculateByCuota && (!customCuota || customCuota <= 0)}
                                                    helperText={calculateByCuota && (!customCuota || customCuota <= 0) ? "La cuota debe ser mayor a 0" : ""}
                                                    slotProps={{
                                                      input: {
                                                        startAdornment: (
                                                          <InputAdornment position="start">{moneda?.label}$</InputAdornment>
                                                        ),
                                                      },
                                                    }}
                                                    placeholder="Ingrese el valor de la cuota"
                                                    value={formatNumberWithCommas(customCuota) || ''}
                                                    onChange={(e) => {
                                                      var value = parseInt(e.target.value.replaceAll(/,/g, ''));
                                                      setCustomCuota(value || 0);
                                                    }}
                                                  />
                                                  <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5 }}>
                                                    El interés se calculará automáticamente
                                                  </Typography>
                                                </Grid>
                                              </Grid>
                                            )}
                                          </Box>*/}
                                    </>
                                    )
                                })}
                                {general.requiereGarantia && (
                                  <Box boxShadow={1} p={2} borderRadius={3} mt={2} padding={5} data-tour="seleccion-garantia">
                                    <Grid container spacing={2}>
                                      <Grid item size={12}>
                                        <Typography variant="h6" fontWeight={700} textAlign={"left"}>Garantía</Typography>
                                      </Grid>
                                      <Grid item size={12}>
                                        <Typography fontWeight={600} textAlign={"left"} color={"textSecondary"}>Categorías de garantía</Typography>
                                        <Selector
                                          options={general.categoriasGarantia.map(categoria => ({label:categoria,value:categoria}))}
                                          value={formValues.categoriasGarantia}
                                          onChange={(e) => {setFormValuesGarantia({});handleInputChange("categoriasGarantia",e.target.value)}}
                                          placeholder="Categorías de garantía"
                                        />
                                      </Grid>
                                      {formValues.categoriasGarantia && camposGarantiaData.find(categoria => categoria.value === formValues.categoriasGarantia)?.campos.map(campo => (
                                        <Grid item size={6}>
                                          <Typography fontWeight={600} textAlign={"left"} color={"textSecondary"}>{campo.name}</Typography>
                                          {campo.type === "texto" && (
                                          <TextField
                                            fullWidth
                                            value={formValuesGarantia[campo.id] || ''}
                                            onChange={(e) => handleInputChangeGarantia(campo.id,e.target.value)}
                                            placeholder={campo.name}
                                            required={campo.required}
                                            error={errorsGarantia[campo.id]!=undefined? true : false}
                                            helperText={errorsGarantia[campo.id]}
                                          />
                                          )}
                                          {campo.type === "monto" && (
                                            <TextField
                                              fullWidth
                                              value={formatNumberWithCommas(formValuesGarantia[campo.id] || '')}
                                              onChange={(e) => handleInputChangeGarantia(campo.id,e.target.value)}
                                              placeholder={campo.name}
                                              required={campo.required}
                                              error={errorsGarantia[campo.id]!=undefined? true : false}
                                              helperText={errorsGarantia[campo.id]}
                                            />
                                          )}
                                        </Grid>
                                      ))}
                                    </Grid>
                                    </Box>
                                )}
                                <Box display={"flex"} flexDirection={"row"} sx={{position: 'fixed', bottom: 0, left: 0, width: '100%', bgcolor: 'white', p: 2, borderTop: '1px solid #eee'}} data-tour="acciones-prestamo">
                                  <Box sx={{mx:"auto"}}>
                                    <Button variant="outlined"  sx={{maxWidth:200,fontWeight:"bold", marginRight:5,  borderColor:"primary.main"}}>Cuota: {moneda?.label}${formatNumberWithCommas(valorCuota)}</Button>
                                    <Button variant="outlined"  sx={{maxWidth:250,fontWeight:"bold", marginRight:5,  borderColor:"primary.main"}}>Deuda Total: {moneda?.label}${formatNumberWithCommas(deudaTotal)}</Button>
                                  </Box>
                                  <Box sx={{  textAlign: 'right', }}>                                  
                                      <Button variant="outlined"  sx={{width:200,fontWeight:"bold", marginRight:5}} onClick={() => navigate(-1)}>Cancelar</Button>
                                      <Button 
                                        variant="contained" 
                                        color="primarybutton" 
                                        sx={{width:200,fontWeight:"bold", marginRight:5}} 
                                        onClick={() => handleGuardar()}
                                        disabled={isSaving}
                                      >
                                        {isSaving ? 'Guardando...' : `Guardar ${general.requiereSolicitud?'Solicitud':''}`}
                                      </Button>
                                  </Box>
                                </Box>
                            </Grid>
                          </Grid>
                      ) : (
                        <>
                             <Box
                              sx={{
                                minHeight: "70vh",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                fontFamily: `'Inter', 'Noto Sans', sans-serif`,
                              }}
                            >
                              <Container maxWidth="sm" sx={{ p: 2, }}>
                                <Paper
                                  elevation={0}
                                  sx={{
                                    p: 4,
                                    border: 1,
                                    borderColor: "grey.200",
                                    borderRadius: 2,
                                    bgcolor: "background.paper",
                                    boxShadow: (theme) => theme.shadows[1],
                                  }}
                                >
                                  <Stack spacing={3} alignItems="center" textAlign="center">
                                    <Avatar
                                      sx={{
                                        width: 64,
                                        height: 64,
                                        bgcolor: "primary.main",
                                        color: "white",
                                      }}
                                    >
                                      <SearchOutlined fontSize="large"/>
                                    </Avatar>

                                    <Stack spacing={0.5}>
                                      <Typography variant="h6" fontWeight={600} color="text.primary">
                                          No Producto Seleccionado
                                      </Typography>
                                      <Typography variant="body2" color="text.secondary">
                                        Seleccione un producto financiero para continuar
                                      </Typography>
                                    </Stack>

                                    <Box sx={{ width: "100%", mt: 1 }} >
                                      <Selector
                                        fullWidth
                                        sx={{backgroundColor:"white"}}
                                        value={financialProductSelected}
                                        onChange={(e) => onProductoFinancieroChange(e)}
                                        options={productosFinancieros.map(producto => ({label:JSON.parse(producto.generales).nombre,value:producto.idprodfinanciero}))}
                                        placeholder="Tipo de producto"/>


                                      <Divider sx={{ my: 2 }}></Divider>

                                    
                                    </Box>
                                  </Stack>
                                </Paper>
                              </Container>
                            </Box>
                          </>
                      )}
                  </Container>
            </Stack>
          </Box>
        </Box>
        <AmortizationDrawer
          open={amortizationDrawerOpen}
          onClose={() => setAmortizationDrawerOpen(false)}
          loanData={amortizationData}
          onDiasPagoQuincenalChange={setDiasPagoQuincenal}
        />
      </AppTheme>
    </Box>
  );
}
